// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Container } from 'unstated';

type HelpCenterState = {
	helpCenterOpen: boolean;
	helpCenterManuallyOpened: boolean;
	showHelpMenuSpotlight: boolean | null;
	featureDiscovered: boolean;
	showDevTools: boolean;
	showGlobalFeedbackCollector: boolean;
};

export class HelpCenterStateContainer extends Container<HelpCenterState> {
	state = {
		helpCenterOpen: false,
		helpCenterManuallyOpened: false,
		showHelpMenuSpotlight: null,
		featureDiscovered: false,
		showDevTools: false,
		showGlobalFeedbackCollector: false,
	};

	open = (helpCenterManuallyOpened = false) =>
		this.setState({ helpCenterOpen: true, helpCenterManuallyOpened });
	close = () => this.setState({ helpCenterOpen: false, helpCenterManuallyOpened: false });
	showHelpMenuSpotlight = () => this.setState({ showHelpMenuSpotlight: true });
	hideHelpMenuSpotlight = () => this.setState({ showHelpMenuSpotlight: false });
	setFeatureDiscovered = (discoveryState) => this.setState({ featureDiscovered: discoveryState });
	showDevTools = () => this.setState({ showDevTools: true });
	hideDevTools = () => this.setState({ showDevTools: false });
	showGlobalFeedbackCollector = () => this.setState({ showGlobalFeedbackCollector: true });
	hideGlobalFeedbackCollector = () => this.setState({ showGlobalFeedbackCollector: false });
}
